__turbopack_context__.v({
  "container": "RarebenefitsBannerSection-module__k03Msq__container",
  "content": "RarebenefitsBannerSection-module__k03Msq__content",
  "cta-container": "RarebenefitsBannerSection-module__k03Msq__cta-container",
  "root": "RarebenefitsBannerSection-module__k03Msq__root" + " " + __turbopack_context__.i(905307)["sectionPadding"],
  "sentence": "RarebenefitsBannerSection-module__k03Msq__sentence",
});
